module.exports = __webpack_public_path__ + "assets/img/hill-6.7d0ddbf7.png";